import { render, staticRenderFns } from "./address-overseas.vue?vue&type=template&id=01ec8961"
import script from "./address-overseas.vue?vue&type=script&lang=js"
export * from "./address-overseas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports